
function penny2Yuan(price) {
    // 当price是-1时,会返回-0,-0===0
    if (price < 0) {
        return price;
    }
    return (price * 0.01).toFixed(2);
}

function isUndefined(val) {
    // eslint-disable-next-line no-undefined
    return val === undefined;
}

function formatNum(val1, val2) {
    return isUndefined(val1)
        ? (isUndefined(val2) ? val2 : +val2)
        : +val1;
}

// 获取限时限额数据,毫秒/元
function getRemainingInfo(info = {}) {
    let {
        // 课程类型,23表示为联报
        course_type,
        courseType,
        productType,
        promotion_list,
        promotionList,
        availablePromotionList
    } = info;

    courseType = formatNum(courseType, course_type);
    courseType = formatNum(courseType, productType);
    promotionList = isUndefined(promotionList) ? promotion_list : promotionList;
    promotionList = isUndefined(promotionList) ? availablePromotionList : promotionList;
    promotionList = promotionList || [];

    const isLianBao = courseType === 23;
    let promotionCountDown = null;
    promotionList.forEach(({
        remainingTime,
        remaining_time,
        remainingCount,
        remaining_count,
        type
    }) => {
        remainingTime = formatNum(remainingTime, remaining_time);
        remainingCount = formatNum(remainingCount, remaining_count);
        // 存在限时或限额
        if ((remainingTime || remainingCount)
                // 目前单课的直减以及联报的联报才有限时限额(2020.12.28),且最多只有一条
                && ((!isLianBao && type === 1) || (isLianBao && type === 2))) {
            promotionCountDown = {
                remainingTime,
                remainingCount
            };
        }
    });
    return promotionCountDown;
}

// 判断是否存在优惠价格
function hasPromotion(info = {}) {
    let {
        price,
        promotion_price,
        promotionPrice,
        priceFen,
        promotionPriceFen
    } = info;

    price = formatNum(priceFen, price);
    promotionPrice = formatNum(promotionPriceFen, promotionPrice);
    promotionPrice = formatNum(promotionPrice, promotion_price);

    // 当优惠价不存在或优惠价小于0或大于等于现价,表示没有优惠
    if (isUndefined(promotionPrice)
            || promotionPrice < 0 || promotionPrice >= price) {
        return false;
    }

    return true;
}

// 判断是否存在限时限额
export function hasUrgeInfo(info) {
    return !!getRemainingInfo(info);
}

// 获取价格信息(课程卡片/班级卡片),毫秒/元
export function getPriceInfo(info = {}, opts = {}) {
    // penny为true表示价格单位是分
    const {penny} = opts;

    let {
        // 课程卡片时有班级数
        subclazz_count = 0,
        subclazzCount,
        // 商品现价
        price,
        price_fen,
        priceFen,
        origPriceFen,
        // 商品原价(boss上配置的)
        orig_price,
        origPrice,
        orig_price_fen,
        // 商品优惠价(基于现价和优惠活动计算得到的价格)
        promotion_price,
        promotionPrice,
        promotion_price_fen,
        promotionPriceFen
    } = info;

    price = priceFen || price_fen || +price;
    subclazzCount = formatNum(subclazzCount, subclazz_count);
    origPrice = origPriceFen || orig_price_fen || formatNum(origPrice, orig_price);
    promotionPrice = promotionPriceFen || promotion_price_fen || formatNum(promotionPrice, promotion_price);

    if (penny) {
        price = penny2Yuan(price);
        origPrice = penny2Yuan(origPrice);
        promotionPrice = penny2Yuan(promotionPrice);
    }

    // 当班级数大于1时,价格后面要加上“起”
    const multi = subclazzCount > 1;
    const bossPrice = {price, origPrice, multi};

    if (!hasPromotion(info)) {
        return bossPrice;
    }

    const promotion = getRemainingInfo(info);

    // 存在优惠时,价格为优惠价,划线价为现价
    return {
        price: promotionPrice,
        origPrice: price === priceFen ? price * 0.01 : price,
        multi,
        // 优惠价限时倒计时,毫秒
        remainingTime: promotion && promotion.remainingTime,
        // 优惠价限额
        remainingCount: promotion && promotion.remainingCount,
        // 倒计时基准时间
        baseTimestamp: Date.now()
    };
}
